import { render, staticRenderFns } from "./CustomDetailsTypePage.vue?vue&type=template&id=20de7dae"
import script from "./CustomDetailsTypePage.vue?vue&type=script&lang=ts"
export * from "./CustomDetailsTypePage.vue?vue&type=script&lang=ts"
import style0 from "./CustomDetailsTypePage.vue?vue&type=style&index=0&id=20de7dae&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports